import React from "react"
import PropTypes from "prop-types"
import {ThemeProvider} from "styled-components"
import mainTheme from "@irati/ui/src/global/theme"

import Address from "@irati-web/geolocation/src/components/Address/Address"
import Saving from "@irati-web/perks/src/components/Saving"
import {RouterLink} from "@irati/ui/src/Link"
import {FormattedMessage} from "@irati/utils/lang"
import {connect} from "@irati/store"
import getCurrency from "@irati/deals/helpers/deals/currency"
import {geolocationTracking} from "@irati-tracking/geolocation"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import Flex from "@irati/ui/src/Flex"
import {H3} from "@irati/ui/src/Typography"

import {
  StyledDefaultInfoWindow
} from "./styled/InfoWindow"

const handleViewPerkDetailClick = (searchTerm) => {
  geolocationTracking.searchByLocationClickViewPerk("map", searchTerm)
}

const InfoWindow = ({deal, className, isMobile, searchTerm, arrowPosition}, {apps}) => {
  const {header, location, savings, urlSlug} = deal
  const {streetAddress, city, postCode} = location
  return (
    <ThemeProvider theme={mainTheme}>
      <StyledDefaultInfoWindow className={className} arrowPosition={arrowPosition}>
        <Flex width="100%" justifyContent="space-between">
          <div>
            {!isMobile && <H3>{header}</H3>}
            <Address title={streetAddress} city={city} postCode={postCode} />
          </div>
          {!isMobile &&
          <Flex direction="column" justifyContent="space-between">
            <Saving
              header={savings.userSavings.header}
              saving={savings.userSavings.value}
              type={savings.userSavings.type}
              currency={getCurrency(deal)} />
            <RouterLink
              app={apps.PERKS}
              to={`/info/${urlSlug}`}
              onClick={() => handleViewPerkDetailClick(searchTerm)}>
              <Flex alignItems="center">
                <FormattedMessage id="search.components.searchAllByLocation.infoWindow.deal.link.text" />
                <Icon icon={IconTypes.chevronRight} marginLeft />
              </Flex>
            </RouterLink>
          </Flex>
          }
        </Flex>
      </StyledDefaultInfoWindow>
    </ThemeProvider>
  )
}

InfoWindow.propTypes = {
  deal: PropTypes.object.isRequired,
  className: PropTypes.string,
  isMobile: PropTypes.bool.isRequired,
  arrowPosition: PropTypes.oneOf([
    "top",
    "right",
    "bottom",
    "left"
  ]),
  searchTerm: PropTypes.string
}

InfoWindow.defaultProps = {
  className: null,
  arrowPosition: "top",
  searchTerm: ""
}

InfoWindow.contextTypes = {
  apps: PropTypes.object.isRequired
}

const mapStateToProps = ({mq}) => {
  return {
    isMobile: mq.lessThan.medium
  }
}

export default connect(mapStateToProps)(InfoWindow)
